import firestoreServices from '../services/firestore.service';

const specialtiesFirestoreServices = firestoreServices('specialties');

const getSubcollection = async doc => {
  let data = doc.data();
  for (let key in data) {
    const item = data[key];
    if (typeof item === 'object' && item && item.parent) {
      await firestoreServices(item.parent.id).get(item.id, async itemData => {
        data[key] = itemData;
      });
    }
  }
  return { id: doc.id, ...data };
};

const listElements = queryResult => {
  const elements = queryResult.docs.map(async (doc, _) => {
    return await getSubcollection(doc);
  });

  return Promise.all(elements);
};

export default {
  ...specialtiesFirestoreServices,
  getAll: (onResult, onError = _ => {}) =>
    specialtiesFirestoreServices
      .collectionRef()
      .get()
      .then(async queryResult => onResult(await listElements(queryResult)))
      .catch(onError),
};
